<template>
  <div class="delivery-receipt-product-list">
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" height="300">
        <el-table-column prop="ReceiptNumber" label="ERP发货单号" align="left" />
        <el-table-column prop="orderNumber" label="订单编号" align="left" />
        <el-table-column prop="MaterialCode" label="物品代码" align="left" />
        <el-table-column prop="ProductName" label="产品名称" align="left" />
        <el-table-column prop="ProductCount" label="数量" align="left" width="90" />
        <el-table-column prop="MaterialUnit" label="单位" align="left" width="70" />
        <el-table-column prop="Physical" label="是否实物" align="left" width="70" />
      </el-table>
    </div>
  </div>
</template>

<script>
import { getDeliveryReceiptProductListByNum } from '@/API/index.js';
export default {
  name: 'DeliveryReceiptProductList',
  data () {
    return {
      tableData: [],
      tableLoading: false
    };
  },
  props: {
    receiptNumber: {
      type: String,
      default: ''
    },
    contractCode: {
      type: String,
      default: ''
    },
    orderNumber: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.initdata();
  },
  methods: {
    initdata () {
      this.tableLoading = true;
      getDeliveryReceiptProductListByNum(this.receiptNumber, this.contractCode, this.orderNumber).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableLoading = false;
          this.tableData = json.data;
        }
      }).catch((res) => {
        this.tableLoading = false;
      });
    }
  }
};
</script>

<style scoped>

</style>
